import { StateCreator } from "zustand";
import { AUTH_HEADER, SECURE_AUTH_TOKEN_KEY, SECURE_BASE_URL_KEY} from "../../base";
import { RemoteRemoveMappings } from "../../data/usecases/remote-remove-mappings";
import { AxiosHttpClient } from "../../infra/http/axios-http-client";
import Endpoints from "../../domain/endpoints";
import { RemoveMapping } from "../../domain/models/remove-mapping";
import Swal from "sweetalert2";
import { getDataKeyFromLocalStorage } from "../../common/utils/AuthToken";

export interface RemoveMappingInterface {
  removeCustomerMapping: Function;
}

const axiosHttpClient = AxiosHttpClient.getInstance();


export const useRemoveMapping: StateCreator<RemoveMappingInterface> = (
  set,
  get
) => ({
  removeCustomerMapping: async (
    customer_info: RemoveMapping,
    handleClose: Function,
    title: string,
    fetchCustomerData: Function,
    handleClearSelectedCustomers: Function
  ) => {
    const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ??"";
    const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);

    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });

    const remoteRemoveMappings = new RemoteRemoveMappings(
      `${BASE_URL}${Endpoints.REMOVE_MAPPINGS}`,
      axiosHttpClient
    );
    let result = await remoteRemoveMappings.remove({ customer_info });
    if (result.success) {
      handleClose(title);
      handleClearSelectedCustomers()
      fetchCustomerData();
      Swal.fire({
        icon: "success",
        title: result.message,
        timer: 3000,
        customClass: {
          container: "swal2-style",
        },
      });
    } else {
      Swal.fire({
        icon: "error",
        title: "Some Error Occured",
        timer: 3000,
        customClass: {
          container: "swal2-style",
        },
      });
    }
  },
});
